import styled, { css } from 'styled-components';
import { tokens } from '../../../../../../../design/tokens';
import { TdTextContentStyled } from './types';
import { PAYMENT_STATUS_ENUM } from './constants/paymentStatus';

export const StyledTdContent = styled.div`
  text-align: center;
  font-weight: 600;
`;

export const LoadingContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

/* Ação primária da linha (GERAR BOLETO / PAGAR) leva o único acento quente,
   igual à ação primária de qualquer outro formulário. "PAGO" é estado, não
   ação: fica em texto neutro e sem cursor de clique. */
export const TdTextContent = styled.span<TdTextContentStyled>`
  ${({ status }) => css`
    text-decoration: underline;
    cursor: pointer;
    color: ${tokens.color.marqueeGold};
    font-family: ${tokens.font.label.family};

    ${status === PAYMENT_STATUS_ENUM.PAID &&
    css`
      color: ${tokens.color.textAsh};
      cursor: inherit;
      text-decoration: none;
    `};
  `}
`;

export const TdTextLinkContent = styled.a`
  text-decoration: underline;
  cursor: pointer;
  color: ${tokens.color.marqueeGold};
  font-family: ${tokens.font.label.family};
`;
